<template>
  <div class='reportDetail font14'>
    <template v-if='curRole==3'><!--老师-->
       <tea-report></tea-report>
    </template>
    <template v-else>
     
     <!--跳绳-->
     <template v-if="type==1">
          <stu-skip></stu-skip>
     </template>
     <!--课堂互动-->
     <template v-else-if="type==3">
          <class-interaction></class-interaction>
     </template>
     <!--打卡-->
     <template v-else>
     <div class='top '>
       <img :src='require("@/assets/img/peo"+gender+".png")' class='img'>
       <p><span class='name font18'>{{loginUser.studentName}}</span><br>{{date}}&nbsp;{{weekList[week]}}</p>
     </div>
     <div class='reportCon'>
         <div class='con' v-if="details.beaconStat">
             <div style="text-align:center">
               <p class='rank'><span>{{details.beaconStat.surpassProportion}}</span>%</p>超过本班同学
              </div>
             <div class='curCon flex-center'>
               <p><span class='color font20'>{{details.beaconStat.beaconWeekNums||'0'}}</span>次<br>本周打卡</p>
               <p><span class='color font20'>{{details.beaconStat.beaconTermNums||'0'}}</span>次<br>本学期打卡</p>
             </div>
         </div>
         <div class="his flex">
            <span class="tit">打卡地点</span>
            <van-dropdown-menu>
                  <van-dropdown-item v-model="year" :options="times" @change='getList(true)'/>
            </van-dropdown-menu>
         <!-- <p>{{list[0].beaconDate[0]}}<van-icon name="arrow-down" /></p> -->
         </div>
         <van-list v-model="isLoading" :finished='isFinish' @load='onLoad' :offset='70' :finished-text="finishText">
            <div class='list flex' v-for="(item,i) in list" :key='i'>
              <p>{{item.beaconDate[1]}}月{{item.beaconDate[2]}}日<br><span>{{item.beaconDate[0]}}年</span></p>
              <p>{{item.beaconSite}}</p>
            </div>
         </van-list>
     </div>
     </template>
    </template>
  </div>
</template>
<script>
import teaReport from './teaReport.vue';
import stuSkip from './skipDetail.vue';
import classInteraction from './classInteraction.vue';
import {getBeaconInfoList,stat} from "@/api/api.report";
  export default {
    data() {
      return {
        date:new Date(),
        list:[],
        details:'',
        times:[{text:'2023',value:'2023'},{text:'2022',value:'2022'}],
        year:'2023',
        type:this.$route.query.type,//1 跳绳 2打卡,
        week:'',
        weekList:['星期日','星期一','星期二','星期三','星期四','星期五','星期六'],
        curRole:this.$store.state.loginUser.currentUserType,//3老师，5家长
        gender:this.$store.state.loginUser.gender||'3',//性别
        pageNo:1,
        pageSize:20,
        isLoading:false,
        isFinish:true,
        finishText:'',
        total:0
      }
    },
   components:{teaReport,stuSkip,classInteraction},
   created(){
     if(this.type){
       sessionStorage.setItem('type',this.$route.query.type);
     }else{
       this.type=sessionStorage.type;
     }
     
     if(this.curRole==3) return false;
     let date=new Date();
     this.date=this.pubMethod.formatDate(date,'yyyy-MM-dd');
     this.week=date.getDay();
     
     if(this.type==2){
      //  document.title='实践打卡';
      this.getDetail();
       this.getList();
     }
     
    },
    methods: {
      getDetail(){
         stat({
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
                 this.details=data.result;
            }
           })
       },
       getList(str){
         if(str){
           this.pageNo=1;
           this.isFinish=true;
           this.list=[];
           this.finishText='';
         }
         getBeaconInfoList({
              pageNo:this.pageNo,
              pageSize:this.pageSize,
              year:this.year,
              studentId:this.loginUser.studentId
           }).then((data) => {
            if (data && data.result) {
              if(data.result.list.length>0){
                    data.result.list.forEach(item=>{
                      item.beaconDate=item.beaconDate.split('-');
                    })
                    this.list=this.list.concat(data.result.list);
              }
                this.isLoading=false;
                this.total=data.result.totalNum;
                if(data.result.totalNum==0){
                  this.isFinish=true;
                }else{
                   if(this.total==this.list.length){
                  this.isFinish=true;
                  this.finishText='-- 没有更多了 --';
                }else{
                  this.isFinish=false;
                }
                }
            }
         })
       },
       onLoad(){
         if(this.isFinish) return
         this.pageNo++;
         this.getList();
       }
    },
  }
</script>
<style lang="scss" >
.reportDetail{
  padding:0rem;
  min-height: 100%;
  .font20{
    font-size: .2rem;
  }
 .flex{
     display: flex;
     justify-content: space-between;
 }
 .top{
   display: flex;
   align-items:center;
   color:#999;
   margin:.2rem .2rem 0rem;
   img{
     border-radius:50%;
     width: .4rem;
     height:.4rem;
     margin-right:10px;
   }
   .name{
     color:#333;
   }
 }
 .reportCon{
   margin:.2rem;
   color:#999;
   .van-dropdown-menu__bar{
     background:transparent;
     height: auto;
     box-shadow: none;
     margin-right: 15px;
   }
   .van-dropdown-menu__title{
     color:#7f7f7f;
     font-size: .12rem;
     &::after{
       border-color:transparent transparent #7f7f7f #7f7f7f ;
     }
   }
   .con{
     background:#fff;
     border-radius:12px;
     padding:.2rem;
     .rank{
         width: .7rem;
         height: .8rem;
         margin: 0px auto;
         background: url(../../assets/img/step/re3.png) no-repeat center top;
         background-size: 100% auto;
         color: #fff;
         span{
           font-weight: bold;
           font-size:.3rem ;
           line-height: .77rem;
         }
     }
    
     .tit{
       font-size:.15rem;
       color:#333;
     }
     .curCon{
       margin-top: .1rem;
       line-height: .3rem;
       p{
         flex: 1;
         text-align: center;
       }
       .color{
         color:#2403df;
         font-weight: 500;
       }
     }
   }
   .his{
     margin:.15rem 0px .08rem;
     .tit{
       color:#333;
       font-size: .14rem;
     }
   }
   .list{
     background:#fff;
     padding:.15rem;
     color:#333;
     font-size: .14rem;
     margin-bottom: 10px;
     align-items: center;
     p:last-child{
       text-align: right;
     }
     span{
       font-size:.12rem;
       color:#999;
     }
   }
 }
}

</style>